import { render } from "./NavBlock.vue?vue&type=template&id=520dad46&scoped=true"
import script from "./NavBlock.vue?vue&type=script&lang=js"
export * from "./NavBlock.vue?vue&type=script&lang=js"

import "./NavBlock.vue?vue&type=style&index=0&id=520dad46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520dad46"]])

export default __exports__